import React, { useMemo, useCallback } from 'react';
import { Box } from '@mui/material';
import PageTitle from '../../../components/PageTitle/PageTitle';
import CardGrid from '../../../components/Layout2/CardGrid/CardGrid';
import { ASSETS_BASE_URL, DOCUMENT_EXTERNAL_ENABLED, DOCUMENT_EXTERNAL_URL } from '../../../config';
import { useTranslation } from 'react-i18next';
import { useSite } from '../../../context/siteContext';
import { buildExternalLoginUrl } from '../../../utilities/externalDocs';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../constants';
import { resolveServiceOptions } from "../../../utilities/customerLocationSettings";
import { useOptions } from "../../../context/optionContext";
const Home = () => {
    const { t } = useTranslation();
    const { selectedSiteData } = useSite();
    const navigate = useNavigate();

    const { optionKeys } = useOptions();
    const amfPremiumService = React.useMemo(
        () => resolveServiceOptions(optionKeys).find((service) => service.key === "amfmethod_premium"),
        [optionKeys]
    );
    const isPremiumFlag = (v) => v === true || String(v).toLowerCase() === "true" || String(v) === "1";
    const hasAmfPremiumAccess = isPremiumFlag(selectedSiteData?.services_meta?.amfmethod_premium);

    const handleTrainingNavigate = () => {
        const trainingPortalUrl = amfPremiumService?.href;
        if (hasAmfPremiumAccess && trainingPortalUrl) {
            window.open(trainingPortalUrl, "_blank", "noopener,noreferrer");
            return;
        }
        navigate("/training");
    };

    const handleDocumentationNavigate = () => {
        //   Internal documentation → SPA navigation
        if (!DOCUMENT_EXTERNAL_ENABLED || !DOCUMENT_EXTERNAL_URL) {
            navigate('/documentation');
            return;
        }

        const username = selectedSiteData?.amf_method_username_ln;
        const password = selectedSiteData?.amf_method_password_ln;

        const loginUrl = buildExternalLoginUrl({
            templateUrl: DOCUMENT_EXTERNAL_URL,
            username,
            password,
        });

        //   Fallback to internal docs if URL build fails
        if (!loginUrl) {
            navigate('/documentation');
            return;
        }
    }
    const homeData = useMemo(() => ([
        { title: t('UI_TEXT.PARTS'), img: `${ASSETS_BASE_URL}/ImageBoxes/parts.jpg`, href: '/parts' },
        { title: t('LABELS.DOCUMENTATION'), img: `${ASSETS_BASE_URL}/ImageBoxes/documentation.jpg`, href: ROUTES.DOCUMENT, onClick: handleDocumentationNavigate },
        { title: t('LABELS.TRAINING'), img: `${ASSETS_BASE_URL}/ImageBoxes/training.jpg`, href: '/training', onClick: handleTrainingNavigate },
        { title: t('LABELS.SERVICE'), img: `${ASSETS_BASE_URL}/ImageBoxes/service.jpg`, href: '/service' },
    ]), [navigate, selectedSiteData, t]);

    return (
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <PageTitle title={t('LABELS.HOME')} />
            <CardGrid data={homeData} />
        </Box>
    );
};

export default Home;
